import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import googleicon from '../../header/images/googleicon.png';


import "./loginfirstpage.css";

const apiUrl = process.env.REACT_APP_API_URL;

const SocialLogin = () => {


  // ❌ ELIMINAT - Google One Tap automat este prea intruziv pentru prima pagină
  // Utilizatorii ar trebui să decidă singuri când vor să se autentifice

  return (
    <div className="social-login-container">
      
      
        <p className="contalearn-subtitle">Creeaza-ti cont si incepe sa inveti, in ritmul tau, pe <strong className="contalearn-brand">ContaLearn</strong>!</p>
      <Link to="/quiz-start" className="social-other-options" style={{marginBottom: '0px', fontWeight: 700, fontSize: '1.1rem'}}><span className="color-buton-social-fp">Incepe gratuit</span></Link>
      <div style={{textAlign: 'center', color: '#888', fontWeight: 500, margin: '6px 0'}}>sau</div>
      <Link to="/login" className="contalearn-secondary-btn" style={{marginTop: 0, fontWeight: 600, fontSize: '1.05rem'}}>Am deja cont</Link>
    </div>
  );
};

export default SocialLogin;
